import { useState, useEffect } from "react";
import { TableCell } from "./TableCell";

function getValidTypeArrayOrNull(value, valuetype) {
  if (valuetype === "number") {
    let ret = value.map((d) => {
      let tt = d !== "" ? Number(d) : Number.NaN;
      return isNaN(tt) ? null : tt;
    });
    let check = ret.filter((a) => a === null);
    return check.length > 0 ? null : ret;
  }
  return value;
}
const equals = (a, b) => a.length === b.length && a.every((v, i) => v === b[i]);

export function ArrayEditCell({ value, onChangeValue, valueType = "number" }) {
  const [oldValue, setOldValue] = useState(value === "---" ? value : (value?.join("; ") ?? ""));
  const [ownValue, setOwnValue] = useState(oldValue);

  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (oldValue == ownValue) return;
    if (ownValue?.length === 0) {
      onChangeValue([]);
      return;
    }

    let temp = ownValue?.replace(" ", "").split(";");
    let result = getValidTypeArrayOrNull(temp, valueType);

    setIsValid(result !== null);

    if (result === null) {
      return;
    }

    if (!equals(oldValue, result)) {
      onChangeValue(result);
    }
  }, [ownValue]);

  return (
    <TableCell>
      <input
        style={isValid ? {} : { color: "red" }}
        type="text"
        value={ownValue}
        onChange={(e) => {
          setOwnValue(e.target.value);
        }}
      />
    </TableCell>
  );
}
